// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1y2wI","selects":"Documents_selects__1X9Nv"};